import React from "react";
import { Paper } from "@mui/material";

const DSPaper = (props: React.ComponentProps<typeof Paper>) => {
  return <Paper {...props} />;
};

export default DSPaper;
